import { render, staticRenderFns } from "./rightContainer.vue?vue&type=template&id=543c3220&scoped=true&"
import script from "./rightContainer.vue?vue&type=script&lang=js&"
export * from "./rightContainer.vue?vue&type=script&lang=js&"
import style0 from "./rightContainer.vue?vue&type=style&index=0&id=543c3220&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543c3220",
  null
  
)

export default component.exports